import React from 'react'
import { TelemedicineCategoryProvider } from '../../context/TelemedicineCategoryProvider'
import { OneClickPrescribeProvider } from './context/OneClickPrescribeContext'
import { useOneClickPrescribeContext } from './context/OneClickPrescribeContext'

import { Menu } from './components/Menu'
import CasesTable from './components/CasesTable'
import Logs from './components/Logs'
import ErrorBoundary from './components/ErrorBoundary'
import { Page, View } from './styles'

const OneClickPrescribe = ({ providerHasPinSet }) => {
  return (
    <TelemedicineCategoryProvider>
      <OneClickPrescribeProvider providerHasPinSet={providerHasPinSet}>
        <OneClickPrescribeInner/>
      </OneClickPrescribeProvider>
    </TelemedicineCategoryProvider>
  )
}

const OneClickPrescribeInner = () => {
  const { showLogs } = useOneClickPrescribeContext()

  return (
    <Page>
      <ErrorBoundary>
        <Menu/>
      </ErrorBoundary>
      <View>
        <ErrorBoundary>
          {showLogs ? <Logs /> : <CasesTable/>}
        </ErrorBoundary>
      </View>
    </Page>
  )
}

export default OneClickPrescribe
